import { type TFunction } from "i18next";
import { Check, X } from "lucide-react";

import { WFPButton } from "@/components/ui/button";

import { type CommodityListItem, type CurrentCountry } from "./types";
import { isCommodityAvailableToCountry } from "./utils";

const ActionsCell = ({
  commodity,
  currentCountry,
  onClickAddCommodity,
  onClickRemoveCommodity,
  t,
}: {
  commodity: CommodityListItem;
  currentCountry?: CurrentCountry;
  onClickAddCommodity?: (commodity: CommodityListItem) => void;
  onClickRemoveCommodity?: (commodity: CommodityListItem) => void;
  t: TFunction;
}) => {
  const isAvailable = isCommodityAvailableToCountry(commodity, currentCountry?.id);

  if (isAvailable) {
    return (
      <WFPButton
        type="button"
        variant="destructive-secondary"
        size="sm"
        onClick={() => onClickRemoveCommodity?.(commodity)}
      >
        <X className="size-4" aria-hidden="true" />
        {t("commodities.list.removeButton", { country: currentCountry?.name })}
      </WFPButton>
    );
  }

  return (
    <WFPButton
      type="button"
      variant="success-secondary"
      size="sm"
      onClick={() => onClickAddCommodity?.(commodity)}
    >
      <Check className="size-4" aria-hidden="true" />
      {t("commodities.list.addButton", { country: currentCountry?.name })}
    </WFPButton>
  );
};

export { ActionsCell };
